import React, { useState, useEffect } from "react";
import VideoStyleForm from "./videostyleForm";
import Sidebar from "../Sidebar";
import { useNavigate } from "react-router-dom";
import { Trash2, Pencil } from "lucide-react";
import axios from "axios";

const VideoStylesTable = () => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [videoStyles, setVideoStyles] = useState([]);
  const [activeSidebarItem, setActiveSidebarItem] = useState("video-style");
  const [editingVideoStyle, setEditingVideoStyle] = useState(null);

  const handleSidebarItemClick = (itemId, path) => {
    navigate(path);
    setActiveSidebarItem(itemId);
  };

  const handleAddNew = () => setShowForm(true);
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this story type?")) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/delete-video-style/${id}`,
          {
            withCredentials: true,
          },
        );
        await getVideoTypes();
      } catch (err) {
        console.error("Error deleting story type:", err);
      }
    }
  };
  const handleEditingVideoStyle = (videoStyle) => {
    setEditingVideoStyle(videoStyle);
    setShowForm(true);
  };
  const handleCloseForm = () => setShowForm(false);
  const getEffortColor = (level) => {
    if (level <= 1.5) return "bg-green-100 text-green-800"; 
    if (level <= 2.5) return "bg-yellow-100 text-yellow-800"; 
    return "bg-red-100 text-red-800"; 
  };

  const getVideoTypes = async () => {
    try {
      const videoTypes = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-video-styles`,
        { withCredentials: true },
      );
      setVideoStyles(videoTypes.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getVideoTypes();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar
        activeSidebarItem={activeSidebarItem}
        onSidebarItemClick={handleSidebarItemClick}
      />
      <div className="flex-1">
          <div className="bg-white rounded-lg shadow-sm">
            {/* Header */}
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">Video Styles</h2>
              <button
                onClick={handleAddNew}
                className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
                Add New Style
              </button>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-200">
                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">
                      Style Name
                    </th>
                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">
                      Effort Level
                    </th>

                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {videoStyles?.map((style) => (
                    <tr key={style.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {style.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getEffortColor(style.effortLevel)}`}
                        >
                          Level {style.effortLevel}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <div className="flex space-x-4">
                           <button
                              onClick={() => handleEditingVideoStyle(style)}
                              className="text-blue-600 hover:text-blue-900 p-2 rounded-md hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            >
                              <Pencil className="w-5 h-5" />
                            </button>
                          <button
                            onClick={() => handleDelete(style._id)}
                            className="text-red-600 hover:text-red-900 transition-colors duration-200"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

        {/* Modal */}
        {showForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full">
              <VideoStyleForm
                onClose={handleCloseForm}
                initialData={editingVideoStyle}
                getVideoTypes={getVideoTypes}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoStylesTable;
